export const associatedServicesData: {
  readonly [key: string]: {
    services: string[];
    relevance: string[];
    recommend: { [key: string]: string[] };
  };
} = {
  // services 子服务   relevance 关联开通    recommend 推荐开通   key和服务名称匹配
  Player: {
    services: [],
    relevance: ['Custom Data / Player Table'],
    recommend: {
      Player: [
        'CustomData',
        'DS Hosting',
        'Friends',
        'Game Items',
        'Command',
        'Telemetry',
      ],
    },
  },
  Battle: {
    services: ['Party', 'Lobby', 'Custom Tags'],
    relevance: ['DS Hosting / Gamemode'],
    recommend: {
      Party: ['Lobby', 'Matchmaking', 'CustomData', 'Telemetry'],
      Lobby: ['Party', 'Matchmaking', 'DSHosting', 'CustomData', 'Telemetry'],
      // Matchmaking: ['Party', 'Lobby', 'DSHosting', 'CustomData', 'Telemetry'],
    },
  },
  Matchmaking: {
    services: ['Matchmaker', 'SkillRating', 'FactionSet'],
    relevance: [],
    recommend: {},
  },
  'DS Hosting': {
    services: ['DS', 'Gamemode'],
    relevance: ['Battle / Custom Tags'],
    recommend: {},
  },
  'Custom Data': {
    services: ['Player Table', 'Party Table', 'Lobby Table', 'Guild Table'],
    relevance: [],
    recommend: {},
  },
  'Auto-Task': {
    // services: ['Microservice', 'Goals'],
    services: ['Goals', 'BattlePass'],
    relevance: [],
    recommend: {
      // Microservice: ['AutoTask'],
      Goals: ['Mails', 'Game Items', 'Microservice'],
    },
  },
  Friends: {
    services: [],
    relevance: [],
    recommend: {},
  },
  'Voice Chat': {
    services: [],
    relevance: [],
    recommend: {
      'Voice Chat': ['Text Chat'],
    },
  },
  'Text Chat': {
    services: [],
    relevance: [],
    recommend: {
      'Text Chat': ['Voice Chat'],
    },
  },
  Guild: {
    services: [],
    relevance: ['Custom Data / Guild Table'],
    recommend: {},
  },
  Leaderboards: {
    services: [],
    relevance: [],
    recommend: {},
  },
  Mails: {
    services: [],
    relevance: [],
    recommend: {
      Mails: ['Game Items'],
    },
  },
  Command: {
    services: [],
    relevance: [],
    recommend: {},
  },
  'Add-ons': {
    services: [],
    relevance: [],
    recommend: {},
  },
  Telemetry: {
    services: [],
    relevance: [],
    recommend: {},
  },
  Notifications: {
    services: [],
    relevance: ['Player'],
    recommend: {},
  },
};
